import { createAsyncThunk } from '@reduxjs/toolkit'
import { gameCloseService, loginService } from 'network/services/auth.service'
import { setFreeRound } from 'redux-store/redux/slices/auth.slice'
import { setServerSeedHash } from 'redux-store/redux/slices/gameSettings.slice'
import { applyThemeToDocument } from 'theme/themes'
import { signIn, signOut } from 'utils/common-services/cookie.service'

export const userLogin = createAsyncThunk('user/login', async ({ payload, history }, thunkApi) => {
  try {
    const res = await loginService(payload)
    if (res) {
      thunkApi.dispatch(setServerSeedHash(res?.serverSeedHash))
      thunkApi.dispatch(setFreeRound(res))
      applyThemeToDocument(res?.themeId)
      signIn({ token: res?.accessToken })
    }
    return res
  } catch (error) {
    return thunkApi.rejectWithValue(error[0].description)
  }
})

export const gameClose = createAsyncThunk('user/game-close', async (data, thunkApi) => {
  try {
    const res = await gameCloseService()
    if (res) {
      signOut()
    }
    return res
  } catch (error) {
    return thunkApi.rejectWithValue(error[0].description)
  }
})
